module.exports = __webpack_public_path__ + "static/media/client22.44c12195.webp";